export default __webpack_public_path__ + "static/wish-you-were-here-desktop-06a0839cf996470712c1928dfacd2ff8.webp";